import {forwardRef, useState} from 'react';
import {
  CaptureCamera,
  cn,
  type CaptureCameraProps,
  type WebcamRefTypes,
} from '@chekinapp/ui';
import styles from './captureReveal.module.css';

const RevealCaptureCamera = forwardRef<WebcamRefTypes, CaptureCameraProps>(
  ({onReady, className, ...props}, ref) => {
    const [isStreaming, setIsStreaming] = useState(false);

    const handleReady = () => {
      setIsStreaming(true);
      onReady?.();
    };

    return (
      <CaptureCamera
        ref={ref}
        className={cn(isStreaming ? styles.shown : styles.hidden, className)}
        onReady={handleReady}
        {...props}
      />
    );
  },
);
RevealCaptureCamera.displayName = 'RevealCaptureCamera';

export {RevealCaptureCamera};
